import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { NatsTraceEntry } from './types'

const MAX_ENTRIES = 500

export const useNatsInspectorStore = defineStore('nats-inspector', () => {
  const entries = ref<NatsTraceEntry[]>([])
  const visible = ref(false)
  const filterKind = ref<'all' | 'request' | 'event'>('all')
  const filterSubject = ref('')

  const filtered = computed(() => {
    let result = entries.value
    if (filterKind.value !== 'all') {
      result = result.filter((e) => e.kind === filterKind.value)
    }
    if (filterSubject.value) {
      const q = filterSubject.value.toLowerCase()
      result = result.filter((e) => e.subject.toLowerCase().includes(q))
    }
    return result
  })

  const pushEntry = (entry: NatsTraceEntry) => {
    entries.value.unshift(entry)
    if (entries.value.length > MAX_ENTRIES) {
      entries.value.length = MAX_ENTRIES
    }
  }

  const clear = () => {
    entries.value = []
  }

  const toggle = () => {
    visible.value = !visible.value
  }

  return { entries, visible, filterKind, filterSubject, filtered, pushEntry, clear, toggle }
})
